import { Route, Routes } from "react-router-dom";
import IndexPage from "./IndexPage";

const IncOrdersRoutes = () => {
  return (
    <Routes>
      <Route>
        <Route index element={<IndexPage />} />
      </Route>
    </Routes>
  );
};

export default IncOrdersRoutes;
